const ErrorPage = () => {
  return (
    <>
      <main>
        <h1>Opps something went wrong</h1>
        <p>Could not find this page</p>
      </main>
    </>
  );
};

export default ErrorPage;
